import { ReactComponent as LogoHuge } from "../../assets/icons/LogoHuge.svg";
import "./footer.css"

const Footer = () => {
    return (
        <div style={{ backgroundColor: "var(--royalBlue)" }}>
            <div className="footer-main">

                <div className="footer-one">
                    <LogoHuge />

                    <div className="footer-sub">
                        <p className="footer-title-que">Follow Us</p>
                        <div className="social-div">
                            {/* <p className="footer-title" onClick={() => window.open('https://www.facebook.com/', '_blank')} style={{ cursor: 'pointer' }}>Facebook</p> */}
                            <p className="footer-title" onClick={() => window.open('https://www.instagram.com/_nd_tailor?igsh=MTBoZnF2aGowZTg5Zw==', '_blank')} style={{ cursor: 'pointer' }}>Instagram</p>
                            {/* <p className="footer-title" onClick={() => window.open('https://twitter.com/', '_blank')} style={{ cursor: 'pointer' }}>Twitter</p> */}

                        </div>
                    </div>
                </div>


                <p className="footer-subtitle">© {new Date().getFullYear()} ND Tailor. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Footer;